<template>
  <div id="slide">
    <vue-range-slider ref="slider" v-model="seleccionado" :piecewise="true" :piecewise-label="true" :value="seleccionado" :min="min" :max="max" :min-range="1" :max-range="5" :formatter="value => `Service ${value}`" :tooltip-merge="false" :enable-cross="true" @slide-end="actualizar" @drag-end="actualizar"></vue-range-slider>
  </div>
</template>

<script>
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
export default {
  name: "Slide",
  components: {
    VueRangeSlider
  },
  data() {
    return {
      min: 1,
      max: 5,
      seleccionado: [1,3]
    }
  },
  mounted: function() {
  },
  methods: {
    actualizar() {
      if(this.seleccionado[1] < 3) {
        this.seleccionado = [1,3]
      } else if(this.seleccionado[1] == 3) {
        this.seleccionado = [1,3]
      } else if(this.seleccionado[1] == 4) {
        this.seleccionado = [4,5]
      } else {
        this.seleccionado = [4,5]
      }
    }
  }
};
</script>

<style lang="scss">
  #slide .slider-dot:first-child {
    display: none!important;
  }
</style>
